export const getSubcategories = state => state.subcategories;

export const getSubcategoriesSearchTerm = state =>
  state.subcategories.searchTerm;

export const getCurrentPage = state => state.subcategories.currentPage;
